import { HttpMethod, HttpOption } from '@/utils/http-client'
import { FundMemberDetailRequest } from '@/api/model/cash'

export class CashAPIConstant {
    fundMemberDetailPage = (data: FundMemberDetailRequest): HttpOption => ({
        url: '/fundcloud/fundMemberDetail/selectFundMemberDetailPage',
        method: HttpMethod.POST,
        data
    })
}
